import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { connectorById } from 'scaleflow/utils/connectors-config';

class ConnectorsGithubPublicRoute extends Route {
  model() {
    return connectorById('github-public');
  }
}

export default instrumentRoutePerformance(ConnectorsGithubPublicRoute);
